import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Result, Spin } from 'antd';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireClaim?: 'admin' | 'clubOwner';
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requireClaim }) => {
  const { user, features, loading } = useAuth();
  const isAdmin = user?.admin === true || features?.admin === true;
  const isClubOwner = user?.clubOwner === true || features?.clubOwner === true;

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  if (requireClaim === 'admin' && !isAdmin) {
    return (
      <Result
        status="403"
        title="Access Denied"
        subTitle="You don't have permission to view this page."
      />
    );
  }
  if (requireClaim === 'clubOwner' && !(isClubOwner || isAdmin)) {
    return (
      <Result
        status="403"
        title="Access Denied"
        subTitle="Club owner access is required to view this page."
      />
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;
